import { render } from "./SchedulerNew.vue?vue&type=template&id=495fe656&scoped=true"
import script from "./SchedulerNew.vue?vue&type=script&lang=js"
export * from "./SchedulerNew.vue?vue&type=script&lang=js"

import "./SchedulerNew.vue?vue&type=style&index=0&id=495fe656&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495fe656"]])

export default __exports__